import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes } from "../../../config/enums.js";
import MultiColList from "./MultiColList.svelte";

export default {
    component: MultiColList,
    name: "Multi Column List",
    description: "Grid layout for displaying multiple columns",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-multicollist--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/grid-pattern.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2Fd296f6550ece4db2b80e2e803e423281",
    inputs: [
        {
            friendlyName: "Title",
            name: "title",
            type: "text",
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H2,
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Number of Columns",
            name: "numberOfCols",
            type: "number",
            defaultValue: 3,
            helperText: "Number of columns to display (e.g. 1–6).",
        },
        {
            friendlyName: "Grid Items",
            name: "cell",
            type: "list",
            subFields: [
                {
                    friendlyName: "Text",
                    name: "text",
                    type: "richText",
                },
            ],
        },
    ],
};
